module.exports = __webpack_public_path__ + "static/media/web_background_night.1ef0eae9.png";